import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppComponent } from "./app.component";
import { DashboardComponent } from "./components/dashboard/dashboard.component";
import { DashboardV2Component } from "./components/dashboard-v2/dashboard-v2.component";
import { SiteLayoutComponent } from "./components/site-layout/site-layout.component";
import { AuthLayoutComponent } from "./components/auth-layout/auth-layout.component";
import { LoginComponent } from "./components/login/login.component";
import { OrdersComponent } from "./components/orders/orders.component";
import { AccountAdminComponent } from "./components/account-admin/account-admin.component";
import { AccountDetailComponent } from "./components/account-detail/account-detail.component";
import { AccountMessageComponent } from "./components/account-message/account-message.component";
import { RedBubbleOrderComponent } from "./components/red-bubble-order/red-bubble-order.component";
import { AsinReportComponent } from './components/asin-report/asin-report.component';
import { CheckTrademarkComponent } from './components/check-trademark/check-trademark.component';
import { MerchantListComponent } from './components/merchant-list/merchant-list.component';
import { AutoCommandsComponent } from './components/auto-commands/auto-commands.component';
import { InventoryComponent } from './components/inventory/inventory.component';

const routes: Routes = [
  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      { path: '', component: LoginComponent, pathMatch: 'full' },
      { path: 'login', component: LoginComponent }
    ]
  },
  {
    path: '',
    component: SiteLayoutComponent,
    children: [
      { path: 'dashboard', component: DashboardComponent },
      { path: 'dashboard-v2', component: DashboardV2Component },
      { path: 'orders', component: OrdersComponent, pathMatch: 'prefix' },
      { path: 'accountAdmin', component: AccountAdminComponent },
      { path: 'accountDetail/:accountId', component:  AccountDetailComponent},
      { path: 'accountMessage', component:  AccountMessageComponent}, 
      { path: 'rbOrder', component: RedBubbleOrderComponent },
      { path: 'merchants', component: MerchantListComponent },
      { path: 'asinReport', component: AsinReportComponent },
      { path: 'checkTrademark', component: CheckTrademarkComponent },
      { path: 'autoCommands', component: AutoCommandsComponent },
      { path: 'inventory', component: InventoryComponent },
    ]
  }  
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
